import { toSafeInteger } from "lodash";
import { isDevelopment } from "./common/utils/environment";

const config = {
  hartyAPI: {
    endpoint: isDevelopment()
      ? process.env.HARTY_DEV_ENDPOINT ||
        "https://harty-286207.an.r.appspot.com/api/"
      : process.env.HARTY_ENDPOINT,
    timeout: toSafeInteger(process.env.SERVICE_CORE_API_TIMEOUT) || 20000,
    apiKey: process.env.HARTY_API_KEY || "harty_api_token",
  },
  environment: process.env.NODE_ENV,
  sentry: {
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    org: process.env.SENTRY_ORG,
    project: process.env.SENTRY_PROJECT,
    authToken: process.env.SENTRY_AUTH_TOKEN,
  },
};

export default config;
